const f = {
  color: {
    default: {
      background: "#f9fafaff",
      boxShadow: "#f9fafaff",
      border: "#dfe6ebff",
      text: "#314351ff",
      icon: "#314351ff",
      strong: "#405261ff",
      heading: "#314351ff"
    },
    info: {
      background: "#ebf5ffff",
      boxShadow: "#4176faff",
      border: "#9ecbffff",
      text: "#314351ff",
      icon: "#4176faff",
      strong: "#405261ff",
      heading: "#314351ff"
    },
    warning: {
      background: "#fff6e5ff",
      boxShadow: "#fabf5aff",
      border: "#ffdd99ff",
      text: "#a35214ff",
      icon: "#ffb83dff",
      strong: "#574323ff",
      heading: "#574323ff"
    }
  }
};
export {
  f as promo
};
